export enum AclEntryType {
  Allow = 'ALLOW',
}

export interface AclEntry {
  type: AclEntryType;
  feature: string;
  role: string;
}
